import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pl-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_oss_date_range_picker = _resolveComponent("oss-date-range-picker")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn_add = _resolveComponent("v-btn-add")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "pa-3",
    style: _normalizeStyle(_ctx.$vuetify.display.mobile ? 'width: 100%' : '')
  }, [
    (_ctx.isAuthorized)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.auditCheckKey === undefined)
            ? (_openBlock(), _createBlock(_component_v_row, {
                id: "documents-filter-box",
                class: "mb-2",
                key: _ctx.reloadData,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }, {
                    default: _withCtx(() => [
                      (
                            (_ctx.currentUser.profile.configuration.expenseReport.write ||
                                _ctx.currentUser.profile.configuration.expenseReport.writeOnlySelf) &&
                            !_ctx.$vuetify.display.mobile
                        )
                        ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                            key: 0,
                            block: "",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onNewExpenseReport())),
                            "data-cy": "expenseReports-create",
                            id: "Add",
                            size: "large"
                          }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode(" Ajouter ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.auditCheckKey === undefined)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2",
                              class: "px-1",
                              id: "Interval"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  style: {"background-color":"#fff","border-radius":"15px"},
                                  class: "mx-1",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field, {
                                          modelValue: _ctx.minAmount,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.minAmount) = $event)),
                                          label: 'Min',
                                          color: "secondary",
                                          min: '0',
                                          type: 'string',
                                          "hide-details": "",
                                          "data-cy": "ExpenseReports-min"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "1",
                                      class: "d-flex align-center justify-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                                            _createTextVNode("$oss-chevron-left")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field, {
                                          modelValue: _ctx.maxAmount,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maxAmount) = $event)),
                                          label: 'Max',
                                          color: 'secondary',
                                          min: '0',
                                          type: 'string',
                                          "hide-details": "",
                                          "data-cy": "ExpenseReports-max"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "2",
                              class: "px-1",
                              id: "Statut"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  outlined: "",
                                  label: "Statut note de frais",
                                  modelValue: _ctx.status,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.status) = $event)),
                                  items: 
                                _ctx.allExpenseStatus.map((status) => ({
                                    value: status,
                                    text: _ctx.getStatusFormat(status),
                                }))
                            ,
                                  "hide-details": true,
                                  "item-value": "value",
                                  "data-cy": "ExpenseReports-statut",
                                  density: "compact",
                                  "item-title": (item) => item.text
                                }, null, 8, ["modelValue", "items", "item-title"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "2",
                              class: "px-1",
                              id: "Date"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oss_date_range_picker, {
                                  begin: _ctx.beginDate,
                                  end: _ctx.endDate,
                                  "hide-details": "",
                                  dense: "",
                                  onChangeDateRange: _ctx.onDateRangeChanged,
                                  prefixDataCy: "ExpenseReports"
                                }, null, 8, ["begin", "end", "onChangeDateRange"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '11' : '2',
                          class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pb-2' : 'px-1'),
                          id: "Search"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              outlined: "",
                              modelValue: _ctx.search,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
                              "append-inner-icon": "$fa-search",
                              clearable: "",
                              "onClick:clear": _cache[5] || (_cache[5] = ($event: any) => (_ctx.search = '')),
                              label: "Recherche",
                              "hide-details": true,
                              "data-cy": "ExpendReports-search",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["cols", "class"]),
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "1",
                              class: "px-1",
                              id: "Delete"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn_icon, _mergeProps({
                                      medium: "",
                                      text: "",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearFilter())),
                                      class: "btn-filter",
                                      "data-cy": "ExpenseReports-refreshFilters"
                                    }, props), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { medium: "" }, {
                                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                                            _createTextVNode("$delete")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1040)
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "Réinitialiser les filtres", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 4,
                              cols: "1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_TutorialButtonDialog, { starterComponents: 'ExpenseReports;' })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.$vuetify.display.mobile && _ctx.auditCheckKey !== undefined)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 5,
                              class: "d-flex justify-end px-1",
                              cols: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  modelValue: _ctx.isIgnored,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isIgnored) = $event)),
                                  label: 'Filtrer les alertes ignorés',
                                  style: {}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              class: "d-flex justify-end",
                              cols: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  modelValue: _ctx.isIgnored,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isIgnored) = $event)),
                                  "hide-details": "",
                                  label: "Filtrer les alertes ignorés",
                                  style: {}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            id: "Details"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  (!_ctx.$vuetify.display.mobile)
                    ? (_openBlock(), _createBlock(_component_oss_data_table, {
                        key: 0,
                        modelValue: _ctx.expenseReportsSelected,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.expenseReportsSelected) = $event)),
                        headers: _ctx.headers,
                        items: _ctx.items,
                        page: _ctx.pagination.page,
                        sortBy: _ctx.pagination.sortBy,
                        sortDesc: _ctx.pagination.descending,
                        "items-per-page": _ctx.pagination.rowsPerPage,
                        "items-length": _ctx.pagination.totalItems,
                        loading: _ctx.loading,
                        "table-hover": true,
                        "hide-default-header": "",
                        dense: true,
                        striped: true,
                        "show-select": true,
                        "hide-default-footer": "",
                        "fixed-header": "",
                        onClickRow: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openExpenseReport($event.id))),
                        onLoadMore: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadMore())),
                        prefixCy: "ExpenseReports"
                      }, {
                        "no-data": _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "py-3",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onNewExpenseReport()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex justify-center"
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode(" Aucune note de frais déclarée ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "py-3 d-flex justify-center"
                              }, {
                                default: _withCtx(() => [
                                  (
                                            _ctx.currentUser.profile.configuration.expenseReport.write ||
                                            _ctx.currentUser.profile.configuration.expenseReport
                                                .writeOnlySelf
                                        )
                                    ? (_openBlock(), _createBlock(_component_v_btn_add, { key: 0 }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        menu: _withCtx(({ item, close }) => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              (_ctx.auditCheckKey && item.auditCheckStatus !== 'IGNORE')
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    onClick: _withModifiers(($event: any) => {
                                        _ctx.ignoreCheck(item);
                                        close();
                                    }, ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                                          _createTextVNode("Ignorer")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.auditCheckKey && item.auditCheckStatus === 'IGNORE')
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 1,
                                    onClick: _withModifiers(($event: any) => {
                                        _ctx.ignoreCheck(item);
                                        close();
                                    }, ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                                          _createTextVNode("Rétablir")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_list_item, {
                                onClick: _withModifiers(($event: any) => {
                                        _ctx.deleteLoading = false;
                                        _ctx.toDeleteExpenseReportId = item.id;
                                        _ctx.deleteDialog = true;
                                        close();
                                    }, ["stop"])
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "small" }, {
                                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                                      _createTextVNode("$oss-trash")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                                      _createTextVNode("Supprimer")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        "item.name": _withCtx(({ item }) => [
                          _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.auditCheckStatus === "IGNORE" ? "( ignoré )" : "") + " ", 1),
                          (item.uniqueExport && item.uniqueExport.id)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                color: "secondary",
                                size: "small",
                                location: "end"
                              }, {
                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                  _createTextVNode("$oss-already-downloaded")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        "item.amount": _withCtx(({ item }) => [
                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(-item.amount, undefined)), 1)
                        ]),
                        "item.user": _withCtx(({ item }) => [
                          _createTextVNode(_toDisplayString(_ctx.getUserDisplayName(item)), 1)
                        ]),
                        "item.date": _withCtx(({ item }) => [
                          _createTextVNode(_toDisplayString(_ctx.getDateFormated(item)), 1)
                        ]),
                        "item.status": _withCtx(({ item }) => [
                          _createVNode(_component_v_chip, {
                            size: "small",
                            variant: "flat",
                            color: "#ffd983"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                left: "",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode("$label")
                                ])),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getStatusFormat(item.status)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        "sum.amount": _withCtx(({ sum }) => [
                          _createTextVNode(_toDisplayString(sum ? "-" + _ctx.newCommonFormatCurrency(sum, undefined) : ""), 1)
                        ]),
                        "item.action": _withCtx(({ item }) => [
                          (!_ctx.auditCheckKey)
                            ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                key: 0,
                                onClick: _withModifiers(($event: any) => {
                                    _ctx.deleteLoading = false;
                                    _ctx.toDeleteExpenseReportId = item.id;
                                    _ctx.deleteDialog = true;
                                }, ["stop"]),
                                size: "small"
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.auditCheckKey && item.auditCheckStatus !== 'IGNORE')
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                "hide-details": true,
                                outlined: true,
                                rounded: "",
                                onClick: _withModifiers(($event: any) => (_ctx.ignoreCheck(item)), ["stop"]),
                                class: "elevation-0 mt-1",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createTextVNode(" Ignorer ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.auditCheckKey && item.auditCheckStatus === 'IGNORE')
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 2,
                                "hide-details": true,
                                outlined: true,
                                rounded: "",
                                onClick: _withModifiers(($event: any) => (_ctx.ignoreCheck(item)), ["stop"]),
                                class: "elevation-0 mt-1",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createTextVNode(" Rétablir ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "headers", "items", "page", "sortBy", "sortDesc", "items-per-page", "items-length", "loading"]))
                    : (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": "",
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              cols: "12",
                              key: item.id,
                              class: "py-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  elevation: "0",
                                  class: "pa-2",
                                  style: {"border-radius":"8px"},
                                  onClick: _withModifiers(($event: any) => (_ctx.openExpenseReport(item.id)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      style: {"flex-wrap":"nowrap"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          style: {"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"},
                                          class: "flex-grow-1 flex-shrink-0",
                                          cols: "8"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.auditCheckStatus === "IGNORE" ? "( ignoré )" : ""), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          style: {"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"},
                                          class: "flex-grow-1 flex-shrink-1 d-flex justify-end",
                                          cols: "4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              color: "secondary",
                                              size: "small",
                                              location: "start"
                                            }, {
                                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                _createTextVNode("$oss-calendar")
                                              ])),
                                              _: 1
                                            }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.getDateFormated(item)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      style: {"flex-wrap":"nowrap"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          style: {"min-width":"100px","max-width":"100%","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"},
                                          class: "flex-grow-1 flex-shrink-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              size: "small",
                                              color: "secondary",
                                              left: ""
                                            }, {
                                              default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                _createTextVNode("$fa-user")
                                              ])),
                                              _: 1
                                            }),
                                            _createTextVNode(_toDisplayString(_ctx.formatUser(item.user)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, { class: "flex-grow-1 flex-shrink-1 d-flex justify-end align-center" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              left: "",
                                              color: "secondary",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                _createTextVNode("$label")
                                              ])),
                                              _: 1
                                            }),
                                            _createTextVNode(_toDisplayString(_ctx.getStatusFormat(item.status)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_oss_dialog, {
                    modelValue: _ctx.deleteDialog,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.deleteDialog) = $event)),
                    title: "Supprimer cette note de frais ?",
                    onClose: _ctx.closeDelete,
                    onValid: _ctx.deleteExpenseReport,
                    validLoading: _ctx.deleteLoading,
                    width: "60vw"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.deleteText), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onClose", "onValid", "validLoading"]),
                  (_ctx.newExpenseReport)
                    ? (_openBlock(), _createBlock(_component_DocumentWizardDialog, {
                        key: 2,
                        ref: "documentWizardDialog",
                        modelValue: _ctx.newExpenseReport,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newExpenseReport) = $event)),
                        showFirstPrevious: false,
                        companyId: _ctx.companyId,
                        inGlobalStep: 'expenseReport',
                        openCameraOnly: _ctx.openCameraOnly,
                        onCreated: _ctx.onExpenseReportCreated
                      }, null, 8, ["modelValue", "companyId", "openCameraOnly", "onCreated"]))
                    : _createCommentVNode("", true),
                  (_ctx.$vuetify.display.mobile)
                    ? (_openBlock(), _createBlock(_component_v_btn_add_icon, {
                        key: 3,
                        modelValue: _ctx.fab,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fab) = $event)),
                        style: {"position":"fixed","bottom":"60px","right":"60px","box-shadow":"10px 10px 7px rgba(0, 0, 0, 0.06)"},
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onNewExpenseReport()))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ], 4))
}